import { IHttpClient } from './interfaces/IHttpClient'
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import store from '@/store/modules/authentication'
import Vue from 'vue'

class HttpClient implements IHttpClient {
  // tslint:disable-next-line: variable-name
  private _http: AxiosInstance

  constructor() {
    this._http = axios.create({
      baseURL: process.env.VUE_APP_APIM_BASE_URL,
      timeout: 0,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    // Request Interceptor
    this._http.interceptors.request.use(
      (config) => {
        config.headers.common.Authorization = `Bearer ${store.getters.getToken()}`
        return config
      },
      (error) => {
        // switch statement to handle all the error cases
        return Promise.reject(error)
      }
    )

    // Response Interceptor
    this._http.interceptors.response.use(
      (response) => {
        return response
      },
      (error) => {
        // switch statement to handle all the error cases
        return Promise.reject(error)
      }
    )
  }

  public async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.get(url, config)
  }

  public async post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.post(url, data, config)
  }

  public async put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.put(url, data, config)
  }

  public async patch<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.patch(url, data, config)
  }

  public async head<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.head(url, config)
  }

  public async delete<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return await this._http.delete(url, config)
  }

  // Any other http methods to be implemented from the IHttpClient interface.
}

export const httpClient: IHttpClient = new HttpClient()
